import React from "react";
import {
  Box,
  Table,
  Paper,
  styled,
  Button,
  Popover,
  TableRow,
  TableBody,
  TableHead,
  IconButton,
  TableContainer,
  TablePagination,
} from "@material-ui/core";

import {
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
} from "@material-ui/icons";

import SortingTableCell from "../../../components/src/SortingTableCell";
import SortingTableHeader from "../../../components/src/SortingTableHeader2";
import FilterPopover, { IFilter } from "../../../components/src/FilterPopover";
import { colors } from "../../utilities/src/Colors";
import ConfirmModal from "../../../components/src/customComponents/ConfirmationModal.web";
import { LoadingComponent } from "../../../components/src/Loader.web";
import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import {
  renderBaseOnConditions,
  sortStringCondition,
} from "../../utilities/src/CustomBlockHelpers";

import GoldenPointListController, {
  S,
  Props,
  IGoldenPointItem,
  IFilterItem,
  ISection,
} from "./GoldenPointListController.web";

const Strings = {
  pageTitle: "Golden Points",
  addGoldenPoint: "Add Golden Points",
  noRecordFounds: "Golden Point Not found",
  view: "View",
  edit: "Edit",
  deactivate: "Deactivate",
  activate: "Activate",
  active: "Active",
};

export default class GoldenPointList extends GoldenPointListController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.state = {
      endDate: null,
      startDate: null,
      popOverTop: 0,
      popOverLeft: 0,
      popOverOpened: false,
      sectionList: [],
      sectionSelected: [],
      statusSuggestions: [
        { id: "active", title: "Active" },
        { id: "inactive", title: "Inactive" },
      ],
      filters: [
        {
          title: "Golden Point Name",
          type: "autocomplete",
          value: "",
          apiKey: "name",
          options: [],
        },
        {
          title: "Total Points",
          type: "autocomplete",
          value: "",
          apiKey: "total_points",
          options: [],
        },
        {
          title: "Status",
          type: "select",
          value: "",
          options: [
            {
              label: "Active",
              value: "Active",
            },
            {
              label: "Deactivated",
              value: "Deactivated",
            },
          ],
        },
        {
          title: "Section",
          type: "multipleSelect",
          value: [],
          options: [],
        },
        {
          title: "Date",
          type: "doubleDatepicker",
          value: [null, null],
        },
      ],
      filterAnchor: undefined,
      sortingData: {
        name: "",
        start_date_base: "",
        end_date_base: "",
        purchase_start_date: "",
        purchase_end_date: "",
        status: "",
        section: "",
      },
      confirmModalFlag: false,
      confirmModalType: false,
      totalCount: 0,
      goldenPointList: [],
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
        activatePermission: false,
      },
      isLoadingPermission: false,
      isAppliedFilter: false,
      isLoading: false,
    } as S;
    // Customizable Area End
  }

  // Customizable Area Start
  getPopoverData() {
    const { popOverTop, popOverLeft, popOverOpened, permissionStatus } =
      this.state;

    return (
      <Popover
        style={{
          boxShadow: "none",
        }}
        anchorReference='anchorPosition'
        open={popOverOpened}
        onClose={() => this.setState({ popOverOpened: false })}
        anchorPosition={{
          top: popOverTop + 40,
          left: popOverLeft - 80,
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {renderBaseOnConditions(
          permissionStatus.viewPermission ||
            permissionStatus.editPermission ||
            permissionStatus.deactivatePermission,
          <div style={webStyle.popoverContainer}>
            {renderBaseOnConditions(
              permissionStatus.viewPermission,
              <Box
                data-test-id='viewButton'
                onClick={() =>
                  this.props.navigation.navigate("GoldenPointView", {
                    id: this.popOverItemId,
                  })
                }
                sx={webStyle.popoverButton}
              >
                {Strings.view}
              </Box>,
              <></>
            )}
            {renderBaseOnConditions(
              permissionStatus.editPermission,
              <Box
                data-test-id='editButton'
                sx={webStyle.popoverButton}
                onClick={() =>
                  this.props.navigation.navigate("GoldenPointEdit", {
                    id: this.popOverItemId,
                  })
                }
              >
                {Strings.edit}
              </Box>,
              <></>
            )}

            {renderBaseOnConditions(
              permissionStatus.deactivatePermission &&
                this.popOverItemStatus === true,
              <Box
                data-test-id={"inactivateButton"}
                sx={webStyle.popoverButton}
                onClick={() => {
                  this.setState({
                    popOverOpened: false,
                    confirmModalFlag: true,
                  });
                }}
              >
                {Strings.deactivate}
              </Box>,
              <></>
            )}

            {renderBaseOnConditions(
              (permissionStatus.activatePermission as boolean) &&
                this.popOverItemStatus !== true,
              <Box
                data-test-id={"activateButton"}
                sx={webStyle.popoverButton}
                onClick={() => this.onEditApi(true)}
              >
                {Strings.activate}
              </Box>,
              <></>
            )}
          </div>,
          <div style={webStyle.popoverContainer}>
            <Box sx={webStyle.noPermissions}>No Permissions</Box>
          </div>
        )}
      </Popover>
    );
  }
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      totalCount,
      sortingData,
      goldenPointList,
      confirmModalFlag,
      confirmModalType,
      permissionStatus,
      isLoading,
    } = this.state;
    // Customizable Area End

    return (
      <>
        <ConfirmModal
          open={confirmModalFlag}
          handleClose={() =>
            this.setState({
              confirmModalFlag: false,
              confirmModalType: false,
            })
          }
          handleConfirm={this.handleConfirmModal.bind(this)}
          title={
            !confirmModalType
              ? "Confirm Deactivate"
              : "Golden Point Deactivated"
          }
          displayItem={confirmModalType}
          message={{
            id: this.popOverItemId,
            title: this.confirmModalValue,
          }}
          dynamic={!confirmModalType}
          confirmText={!confirmModalType ? "Deactivate" : "Back to Listing"}
        />
        <MainBoxWrapper>
          <Box className='pageWrapper' style={{ paddingTop: "10px" }}>
            <div style={webStyle.headerWrapper}>
              <PageTitle>{Strings.pageTitle}</PageTitle>
              <div style={webStyle.headerButtonPartAccount}>
                <div
                  data-test-id='filterButton'
                  onClick={(event: { currentTarget: {} } | undefined) =>
                    this.handleFilterChange(event)
                  }
                  className={sortStringCondition(
                    this.state.isAppliedFilter,
                    "filterButtonAccount active-filter-border",
                    "filterButtonAccount"
                  )}
                >
                  <FilterIcon color={this.handleReturnColorType()} />
                  {renderBaseOnConditions(
                    this.state.isAppliedFilter,
                    <div className='filterActiveIcon' />,
                    <></>
                  )}
                </div>

                <FilterPopover
                  onClose={() => this.setState({ filterAnchor: undefined })}
                  anchor={this.state.filterAnchor as HTMLDivElement | undefined}
                  onAutoCompleteChange={(title: string, value: string) => {
                    if (title === "Golden Point Name")
                      this.getGoldenPointSuggestionList(value);
                    else if (title === "Section")
                      console.log("Section", title),
                        this.getSectionSuggestionList(value);
                    else if (title === "Status") {
                      this.setState({
                        statusSuggestions: [
                          { id: "active", title: "Active" },
                          { id: "inactive", title: "Inactive" },
                        ],
                      });
                    }
                  }}
                  onFilterChange={(filters: IFilter[]) => {
                    this.setState({ filters });
                    this.onApplyFilter(filters);
                  }}
                  onClearFilter={() => {
                    let updated: IFilterItem[] = this.state.filters.map(
                      (item: IFilterItem) => {
                        if (item.title === "Date") {
                          item.datevalue = { from: undefined, to: undefined };
                          item.value = undefined;
                        } else if (item.title === "Section") {
                          item.value = "";
                        } else {
                          item.value = "";
                        }
                        return item;
                      }
                    );

                    this.setState({
                      filters: updated,
                      sectionSelected: [],
                      startDate: null,
                      endDate: null,
                    });
                  }}
                  refreshFilterState={(filters: IFilterItem[]) =>
                    this.setState({ filters })
                  }
                  filters={this.state.filters as IFilter[]}
                />

                <LoadingComponent
                  isLoading={this.state.isLoadingPermission}
                  height={44}
                  width={160}
                  isAllowed={permissionStatus.createPermission}
                  children={
                    <Button
                      data-test-id='addGoldenPoint'
                      className={"addButton"}
                      onClick={() =>
                        this.props.navigation.navigate("GoldenPointCreate")
                      }
                    >
                      {Strings.addGoldenPoint}
                    </Button>
                  }
                />
              </div>
            </div>

            <TableContainer component={Paper} className='flexItem'>
              {/* NOTE: tableLayout: "fixed" and reduced padding applied in MainBoxWrapper */}
              <Table style={webStyle.table} aria-label='customized table'>
                <TableHead className='stickyHeader'>
                  <TableRow style={{ background: "#204B9C", color: "#FFFFFF" }}>
                    <SortingTableHeader
                      sortingData={sortingData}
                      title='Golden Point Name'
                      sortingKey='name'
                      {...this.sortingProps}
                      type='left'
                      handleHeaderClick={() => null}
                    />
                    <SortingTableHeader
                      sortingData={sortingData}
                      title='Total Points'
                      sortingKey='total_points'
                      {...this.sortingProps}
                      handleHeaderClick={() => null}
                    />
                    <SortingTableHeader
                      sortingData={sortingData}
                      title='Duration'
                      sortingKey=''
                      {...this.sortingProps}
                    />

                    <SortingTableHeader
                      sortingData={sortingData}
                      title='Status'
                      sortingKey='status'
                      {...this.sortingProps}
                      sortingDisabled
                    />
                    <SortingTableHeader
                      sortingData={sortingData}
                      title=''
                      type='action'
                      sortingKey=''
                      {...this.sortingProps}
                      minHeightType={true}
                      sortingDisabled
                    />
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(() => {
                    return goldenPointList.map((item: IGoldenPointItem) => {
                      return (
                        <TableRow
                          key={"table-row-" + item.id}
                          data-test-id={"table-row-" + item.id}
                        >
                          {/* removed width props to allow fixed table layout to distribute space */}
                          <SortingTableCell
                            width='22vw'
                            type='left'
                            content={item.attributes.name}
                          />
                          <SortingTableCell
                            width='22vw'
                            type='middle'
                            content={item.attributes.total_points || "-"}
                          />
                          <SortingTableCell
                            width='30vw'
                            type='middle'
                            content={`${
                              item.attributes.purchase_start_date || "-"
                            } - ${item.attributes.purchase_end_date || "-"}`}
                          />
                          <SortingTableCell
                            width='22vw'
                            type='right'
                            content={
                              item.attributes.status ? "Active" : "Inactive"
                            }
                          />

                          <SortingTableCell
                            width=''
                            type='action'
                            content={
                              <IconButton
                                data-test-id={"moreButton-" + item.id}
                                onClick={(event) => {
                                  const position =
                                    event.currentTarget.getBoundingClientRect();
                                  this.setState({
                                    popOverOpened: true,
                                    popOverLeft: position.left + window.scrollX,
                                    popOverTop: position.top + window.scrollY,
                                  });
                                  this.popOverItemStatus = Boolean(
                                    item.attributes.status
                                  );
                                  this.popOverItemId = item.id;
                                  this.confirmModalValue = item.attributes.name;
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            }
                          />
                        </TableRow>
                      );
                    });
                  })()}
                </TableBody>

                {isLoading && (
                  <>
                    {Array(5)
                      .fill(1)
                      .map((_, index) => (
                        <TableBody key={index} data-test-id='skeletonTable'>
                          <TableRow>
                            {[...Array(6)].map((_, cellIndex) => (
                              <TableRowsSkeleton key={cellIndex} />
                            ))}
                          </TableRow>
                        </TableBody>
                      ))}
                  </>
                )}
              </Table>

              {goldenPointList.length === 0 && !isLoading && (
                <NoRecordFoundText>{Strings.noRecordFounds}</NoRecordFoundText>
              )}
            </TableContainer>

            {goldenPointList.length !== 0 && (
              <TablePagination
                component='div'
                count={totalCount}
                page={this.currentPage - 1}
                rowsPerPage={this.rowPerPage}
                rowsPerPageOptions={[10]}
                onRowsPerPageChange={(
                  e: React.ChangeEvent<{ value: unknown }>
                ) => {
                  this.rowPerPage = e.target.value as number;
                  this.getGoldenPointApi();
                }}
                onPageChange={(_, page: number) => this.onChangePage(page + 1)}
              />
            )}
          </Box>
        </MainBoxWrapper>
        {this.getPopoverData()}
      </>
    );
  }
}

// Customizable Area Start
const NoRecordFoundText = styled("div")({
  fontSize: 16,
  fontWeight: 600,
  textAlign: "center",
});

export const PageTitle = styled("div")({
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "29px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

const MainBoxWrapper = styled("div")({
  // Scoped overrides for Material UI table cells to tighten spacing
  "& .MuiTableCell-root": {
    padding: "8px 12px !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  },
  "& .MuiTableRow-root": {
    height: "48px",
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    padding: "10px 12px !important",
    fontWeight: 600,
    color: "#FFFFFF",
  },
  "& .stickyHeader": {
    zIndex: 2,
  },
  "& .filterButtonAccount": {
    position: "relative",
    marginRight: "24px",
    cursor: "pointer",
    background: colors().white,
    height: "56px",
    color: colors().darkliver,
    width: "56px",
    fontSize: "24px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid",
    borderColor: colors().lightborder,
    "@media only screen and (max-width: 1024px)": {
      fontSize: "16px",
      width: "44px",
      height: "44px",
    },
  },
  "& .active-filter-border": {
    borderColor: colors().cyancobaltblue,
  },
  "& .filterActiveIcon": {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    minWidth: "15px",
    background: colors().cyancobaltblue,
    minHeight: "15px",
    borderRadius: "50%",
  },
  "& .addButton": {
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: colors().white,
    height: "56px",
    width: "184px",
    borderRadius: "8px",
    textTransform: "unset",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px",
      width: "160px",
      height: "44px",
    },
  },
});

export const webStyle = {
  // tableLayout fixed ensures even distribution and prevents big gaps from long content
  table: {
    minWidth: 700,
    tableLayout: "fixed" as "fixed",
  },
  noPermissions: {
    padding: "0 8px",
  },
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 32,
    alignItems: "center",
    flexWrap: "wrap" as "wrap",
  },
  headerButtonPartAccount: {
    display: "flex",
  },
  popoverButton: {
    cursor: "pointer",
    width: "118px",
    height: "33px",
    paddingLeft: "24px",
    backgroundColor: "#FFFFFF",
    color: "#4D4D4D",
    "&:hover": {
      backgroundColor: "#204B9C",
      color: "#FFFFFF",
    },
    paddingTop: "8px",
  },
  popoverContainer: {
    paddingTop: "16px",
    paddingBottom: "16px",
    boxShadow:
      "0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 32px rgba(0, 0, 0, 0.06)",
    borderRadius: "8px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "14px",
  },
};
// Customizable Area End
